import { anatomicSiteService } from '@/services/anatomic-site-service'
import { GET_ANATOMIC_SITES, MERGE_ANATOMIC_SITES } from '@/store/mutation-types'
import merge from 'lodash/merge'
import { normalize } from 'normalizr'
import { schemas } from '@/store/schemas'

export const namespaced = false
export const state = {
  anatomicSites: {}
}
export const mutations = {
  [MERGE_ANATOMIC_SITES](state, anatomicSites) {
    state.anatomicSites = merge({}, state.anatomicSites, anatomicSites)
  }
}
export const actions = {
  async [GET_ANATOMIC_SITES]({ commit }) {
    const response = await anatomicSiteService.getAnatomicSites()
    const normalized = normalize(response.data, schemas.anatomicSiteList)
    commit(MERGE_ANATOMIC_SITES, normalized.entities.anatomicSites)
  }
}
